import { matchesTokens } from '@medcom/shared-ui/utils/tokenSearch.ts';
import type { SheetData } from '../../../../graphql/sheet';

// Sheet search highlights instead of filtering, so these counts exist purely to make matches
// discoverable: a collapsed panel (the accordion only opens one) would otherwise give no hint
// that it contains a hit. Both names are searchable regardless of flipParamNames.
export const countSheetDataMatches = (sheetData: SheetData, tokens: string[]): number =>
  tokens.length
    ? sheetData.groups.reduce(
        (sum, group) => sum + group.parameters.filter(p => matchesTokens(p, tokens, [it => it.shortName, it => it.longName])).length,
        0
      )
    : 0;
